var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.msg)?_c('k-dialog',{staticClass:"k-toast k-flex",attrs:{"transition-name":"k-toast-fade","disable-lock":""}},[_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.msg))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }